export const TELAO = () => `/telao`;
